<template>
  <answer-template
    :answer-type="'redirect'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'change-rule'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Redirect to another rule</template>
    <template v-slot:content>
      <div class="field">
        <div class="control is-expanded">
          <div class="select is-small is-fullwidth">
            <select v-model="inputData.ruleId">
              <option value="">Please select target rule.</option>
              <option v-for="rule in rulesList"
                      :value="rule.id"
                      :key="rule.id"
                      v-show="rule.id !== selectedRuleId">
                <span v-html="getLevelDash(rule.level)"></span>
                {{rule.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'changeRule',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'change_rule',
          ruleId: '',
        };
      },
    },
    selectedRuleId: {
      type: String,
    },
    rulesList: {
      type: Array,
      default() {
        return [];
      },
    },
    isFirst: {
      type: Boolean,
      default: true,
    },
    isLast: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
    },
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
    getLevelDash(level) {
      switch (level) {
        case 1: return '&ensp;';
        case 2: return '&ensp;&ensp;';
        case 3: return '&ensp;&ensp;&ensp;';
        case 4: return '&ensp;&ensp;&ensp;&ensp;';
        default: return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .change-rule {
  }
</style>
